import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fill", "input", "label", "progress"]

  connect() {
    this.update()
  }

  update() {
    const total = this.inputTargets.length
    if (total === 0) return

    const completed = this.inputTargets.filter((input) => input.value.trim() !== "").length
    const remaining = total - completed
    const percentage = (completed / total) * 100
    const complete = remaining === 0

    this.fillTarget.style.width = `${percentage}%`
    this.labelTarget.textContent = complete ? "入力完了 / 20秒" : `あと${remaining}項目 / 20秒`
    this.progressTarget.setAttribute("aria-valuenow", String(completed))
    this.progressTarget.setAttribute(
      "aria-valuetext",
      complete ? `${total}項目すべて入力済み` : `${completed}項目入力済み、あと${remaining}項目`
    )
  }
}
